export var EmailType;
(function (EmailType) {
    EmailType["PERSONAL"] = "PERSONAL";
    EmailType["BUSINESS"] = "BUSINESS";
    EmailType["LISTSERVE"] = "LISTSERVE";
    EmailType["INTERNET"] = "INTERNET";
    EmailType["PROPERTY"] = "PROPERTY";
    EmailType["SALES_OFFICE"] = "SALES_OFFICE";
    EmailType["RESERVATION_OFFICE"] = "RESERVATION_OFFICE";
    EmailType["MANAGING_OFFICE"] = "MANAGING_OFFICE";
})(EmailType || (EmailType = {}));
